import React, { useState } from "react";
import styled from "styled-components";
import _ from "lodash";
import { Row, Col } from "components/shared/layout";
import Button from "components/button";
import Select from "components/select";
import Input from "components/input";
import Layout, { Header } from "../../shared/card-layout";
import { connect } from "formik";
import Modal, { ModalContent, ModalContext } from "components/modal";
import DropZone from "components/dropzone";
import UploadedFile from "components/uploaded-file";

const FormsContainer = styled.div`
  width: 100%;
`;

const QuestionGroup = styled(Row)`
  margin-bottom: 50px;
`;

const FieldWrapper = styled(Col)`
  padding: 10px;
`;

const ButtonWrapper = styled.div`
  margin: 25px auto;
  button {
    min-width: 13.75em;
  }
`;

const uploadType = {
  employ_staff: 'employ_staff_proof',
  employee_contracts: 'employee_contracts_proof',
  job_descriptions: 'job_descriptions_proof',
  hr_policy: 'hr_policy_proof',
};

const StaffingFormLevel1 = connect(({ formik, editable = true }) => {
  const [showUploadType, setShowUploadType] = useState(false);

  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Do you employ staff?' required />
              <FieldWrapper xs={12}>
                <Select
                  name="has_staff"
                  placeholder={"Staff?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
              <FieldWrapper xs={12}>
                <Header title='How many staff do you employ?' required />
                <Select
                  name="num_staff_employed"
                  placeholder={"# Staff Members"}
                  options={_.range(1, 51).map(num => ({ label: num, value: num }))}
                />
              </FieldWrapper>
            </QuestionGroup>

            <Header title='Do you have employee contracts?' required />
            <FieldWrapper xs={12} md={6}>
              <Select
                name="has_employee_contracts"
                placeholder={"Employee Contracts?"}
                options={[
                  {
                    label: 'Yes',
                    value: 'yes'
                  },
                  {
                    label: 'No',
                    value: 'no'
                  }
                ]}
              />
            </FieldWrapper>
            <Header title='Do you have an HR policy?' required />
            <FieldWrapper xs={12} md={6}>
              <Select
                name="has_hr_policy"
                placeholder={"HR Policy?"}
                options={[
                  {
                    label: 'Yes',
                    value: 'yes'
                  },
                  {
                    label: 'No',
                    value: 'no'
                  }
                ]}
              />
            </FieldWrapper>
            <QuestionGroup xs={12}>
              <Header title='Do you have a payroll system?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_payroll_system"
                  placeholder={"Payroll System?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
              <FieldWrapper xs={12}>
                <Header title='What payroll system do you use?' required />
                <Input name="payroll_system" placeholder="Name of Payroll System" />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does your staff have job descriptions?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_job_descriptions"
                  placeholder={"Job descriptions?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
});

const StaffingFormLevel2 = connect(({ formik, editable = true }) => {
  const [showUploadType, setShowUploadType] = useState(false);

  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of employee contracts' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.employee_contracts_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.employee_contracts_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.employee_contracts_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("employee_contracts_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.employee_contracts_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.employee_contracts)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.employee_contracts && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>

            <QuestionGroup xs={12}>
              <Header title='Upload your staff job descriptions' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.job_descriptions_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.job_descriptions_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.job_descriptions_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("job_descriptions_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.job_descriptions_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.job_descriptions)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.job_descriptions && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
          </Layout>
        </Col>

        <Col xs={12} lg={6} style={{ height: 'fit-content'}}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Upload your HR policy' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.hr_policy_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.hr_policy_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.hr_policy_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("hr_policy_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.hr_policy_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.hr_policy)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.hr_policy && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
});


export {
  StaffingFormLevel1,
  StaffingFormLevel2,
};

